export default __webpack_public_path__ + "static/media/Taj Mahal.6709d8ea.svg";